import OrderTransportingOrderAvailableDriversResponse, {
  OrderTransportingOrderAvailableDriversResponseItem,
  OrderTransportingOrderAvailableDriversResponseItemStartingAddress,
  OrderTransportingOrderAvailableDriversResponseItemPlan,
  OrderTransportingOrderAvailableDriversResponseItemPlanCargoOrder,
  OrderTransportingOrderAvailableDriversResponseItemTaxi,
} from "../../../../api/raily/order/transporting-order/available-drivers/order-transporting-order-available-drivers.response";
import OrderTransportingOrderAvailableDrivers, {
  OrderTransportingOrderAvailableDriversItem,
  OrderTransportingOrderAvailableDriversItemPlan,
  OrderTransportingOrderAvailableDriversItemPlanCargoOrder,
  OrderTransportingOrderAvailableDriversItemStartingAddress,
  OrderTransportingOrderAvailableDriversItemTaxi,
} from "./order-transporting-order-available-drivers";

const createCargoOrder = (
  order: OrderTransportingOrderAvailableDriversResponseItemPlanCargoOrder,
): OrderTransportingOrderAvailableDriversItemPlanCargoOrder => {
  return {
    humanId: order.humanId,
  };
};

const createPlan = (
  plan: OrderTransportingOrderAvailableDriversResponseItemPlan,
): OrderTransportingOrderAvailableDriversItemPlan => {
  return {
    cargoOrders: plan.cargoOrders.map(createCargoOrder),
    id: plan.id,
  };
};

const createStartingAddress = (
  addess: OrderTransportingOrderAvailableDriversResponseItemStartingAddress,
): OrderTransportingOrderAvailableDriversItemStartingAddress => {
  return {
    lat: addess.lat,
    lon: addess.lon,
    fullAddress: `${addess.zipCode} ${addess.town}, ${addess.street} ${addess.houseNo} ${addess.apartment}`,
  };
};

const createTaxi = (
  taxi: OrderTransportingOrderAvailableDriversResponseItemTaxi,
): OrderTransportingOrderAvailableDriversItemTaxi => {
  return {
    companyName: taxi.companyName,
    displayName: taxi.displayName,
    fleetPartner: taxi.fleetPartner,
    id: taxi.id,
  };
};

const createDataItem = (
  item: OrderTransportingOrderAvailableDriversResponseItem,
): OrderTransportingOrderAvailableDriversItem => {
  return {
    distance: item.distance,
    firstName: item.firstName,
    id: item.id,
    lastName: item.lastName,
    mobilePrimary: item.mobilePrimary,
    mobilePrimaryPrefix: item.mobilePrimaryPrefix,
    plans: item.plans.map(createPlan),
    startingAddress: createStartingAddress(item.startingAddress),
    taxis: item.taxis.map(createTaxi),
  };
};

const create = (
  response: OrderTransportingOrderAvailableDriversResponse,
): OrderTransportingOrderAvailableDrivers => {
  return response.data.map(createDataItem);
};

const orderTransportingOrderAvailableDriversFactory = {
  create,
};

export default orderTransportingOrderAvailableDriversFactory;
